module.exports = __webpack_public_path__ + "img/icon_map_penguan_zaixian1.b573f452.svg";